import { useApolloClient } from '@apollo/client';
import { Formik } from 'formik';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Row,
} from 'reactstrap';
import * as Yup from 'yup';
import { successMsg } from '../../cache/vars';
import { RESET_PASSWORD } from '../../queries/auth';

const VALIDATION_SCHEMA = Yup.object().shape({
  password: Yup.string().min(8).max(32).required('Required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Required'),
});

const ResetPasswordPage: React.FC = ({
  match: {
    params: { token },
  },
}: any) => {
  const client = useApolloClient();
  const history = useHistory();

  return (
    <Container className="mt-8 pb-5">
      <Row className="justify-content-center">
        <Col lg="5" md="7">
          <Card className="bg-secondary border-0 mb-0">
            <CardBody className="px-lg-5 py-lg-5">
              <Formik
                initialValues={{ password: '', confirmPassword: '' }}
                onSubmit={async (userInfo) => {
                  const resetPasswordResponse = await client.mutate({
                    mutation: RESET_PASSWORD,
                    variables: { password: userInfo.password, token },
                    fetchPolicy: 'no-cache',
                  });

                  if (resetPasswordResponse.data?.resetPassword === 'ok') {
                    history.push('/login');
                    successMsg('Password changed');
                  }
                }}
                validationSchema={VALIDATION_SCHEMA}
              >
                {(props) => {
                  const {
                    values,
                    touched,
                    errors,
                    dirty,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    handleReset,
                  } = props;

                  return (
                    <Form role="form" onSubmit={handleSubmit}>
                      <FormGroup>
                        <Input
                          placeholder="New Password"
                          value={values.password}
                          onChange={handleChange}
                          type="password"
                          invalid={!!errors.password && touched.password}
                          onBlur={handleBlur}
                          name="password"
                        />
                        {errors.password && touched.password ? (
                          <FormFeedback>
                            Password should contain min 8 and max 32 symbols
                          </FormFeedback>
                        ) : (
                          <FormText>Enter new password</FormText>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Input
                          placeholder="Confirm New Password"
                          value={values.confirmPassword}
                          onChange={handleChange}
                          invalid={!!errors.confirmPassword && touched.confirmPassword}
                          type="password"
                          onBlur={handleBlur}
                          name="confirmPassword"
                        />
                        {errors.confirmPassword && touched.confirmPassword ? (
                          <FormFeedback>
                            Password and confirm password should be the same
                          </FormFeedback>
                        ) : (
                          <FormText>Confirm password</FormText>
                        )}
                      </FormGroup>
                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="info"
                          type="submit"
                          disabled={!dirty && isSubmitting}
                        >
                          Reset
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
          <Row className="mt-3">
            <Col xs="6" className="text-left">
              <Link to="/login" className="text-primary">
                <small>Back To Login Page</small>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPasswordPage;
